module.exports = __webpack_public_path__ + "img/mmlz16.1f2bd217.jpg";